import ui from 'store/ui';
import styled, { css } from 'styled-components';
import styledObserver from 'utils/styledObserver';
import { filterValidCSSProperties } from 'utils/ui';

export const StyledImg = styledObserver(styled.img`
  width: 260px;
  ${() => css(filterValidCSSProperties(ui.styles.logo))}
`);
